import { API, Auth } from 'aws-amplify';
import { ErrorWithReferenceURI } from './error/ErrorWithReferenceURI';
import { ErrorWithDetails } from './error/ErrorWithDetails';

/**
 * This method will retrieve JWT token of current session.
 */
const getHeaders = async () => ({
  Authorization: (await Auth.currentSession()).getIdToken().getJwtToken(),
});

export class Api {
  apiName: string;
  constructor(apiName: string) {
    this.apiName = apiName;
  }

  /**
   * This method will create data.
   * @param path API endpoint path
   * @param payload Optional request body
   */
  async post(path: string, payload?: any) {
    const requestOptions: any = {
      headers: await getHeaders(),
      ...(payload && { body: payload }),
    };

    return API.post(this.apiName, path, requestOptions)
      .then((response) => response)
      .catch((error) => {
        if (error.response?.data?.referenceURI) {
          throw new ErrorWithReferenceURI(
            error.response.data.message,
            error.response.data.referenceURI.displayName,
            error.response.data.referenceURI.uri,
          );
        } else if (error.response?.data?.details) {
          throw new ErrorWithDetails(
            error.response.data.message,
            error.response.data.details,
          );
        } else {
          throw new Error(error.response?.data?.message || error.message);
        }
      });
  }

  /**
   * This method will retrive data.
   */
  async get(path: string, queryStringParameters?: any) {
    return API.get(this.apiName, path, {
      headers: await getHeaders(),
      queryStringParameters,
    })
      .then((response) => response)
      .catch((error) => {
        throw new Error(
          error.response?.data?.message || error.response.message,
        );
      });
  }

  /**
   * This method will update data.
   */
  async put(path: string, payload: any) {
    return API.put(this.apiName, path, {
      headers: await getHeaders(),
      body: payload,
    })
      .then((response) => response)
      .catch((error) => {
        if (error.response.data.details) {
          throw new ErrorWithDetails(
            error.response.data.message,
            error.response.data.details,
          );
        } else {
          throw new Error(error.response.data.message);
        }
      });
  }

  /**
   * This method will delete data.
   */
  async delete(path: string, queryStringParameters?: any) {
    return API.del(this.apiName, path, {
      headers: await getHeaders(),
      queryStringParameters,
    })
      .then((response) => response)
      .catch((error) => {
        throw new Error(
          error.response?.data?.message || error.response.message,
        );
      });
  }
}
